// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__zxyvy","errors":"Errors_errors__2LQ0D"};